import axios from "axios";
// import axios,  { API_URL } from '@/helpers/axios'

console.log(`AXIOS CONFIGURACION API: ${process.env.VUE_APP_SERVER_API} `)

export const API_URL = process.env.VUE_APP_SERVER_API || "https://api.clicken1.com.pe/";
export const API_MANAGER = process.env.VUE_APP_API_MANAGER || "https://apimanager.clicken1.com.pe/";
export const PAYPAL_API_CLIENT = process.env.VUE_APP_PAYPAL_API_CLIENT;
export const PAYPAL_SECRET = process.env.VUE_APP_PAYPAL_SECRET;
export const PAYPAL_API = process.env.VUE_APP_PAYPAL_API;


const instance = axios.create({
  baseURL: API_URL,
});

// Authenticated exist in sessionStorage
export const isAuthenticated = async () => {
  return sessionStorage.getItem("token") == undefined ? false : true;
};

// if token expidered
export default instance;
